<template>
    <div :class="mode" class="main-window">
        <div :class="{blurred: blured === true }">
            <transition name="slide-up">
                <StartScreen :language="lang" 
                        v-on:go-next-event="goNext" 
                        v-if="plansza === 'start'" 
                        ></StartScreen>
                <GameDescription :language="lang" 
                        v-on:go-next-event="goNext" 
                        v-on:open-settings="openSettings" 
                        v-else-if="plansza === 'opisGry'"
                        ></GameDescription>
                <NowaGra :language="lang" 
                        v-else-if="plansza === 'nowa-gra'" 
                        v-on:open-settings="openSettings" 
                        v-on:open-description="openDescription" 
                        v-on:go-next-event="goToPlansza" 
                        v-on:join-game-question-event="joinGameQuestion"
                        v-on:back-to-continue="backToContinueGame"
                        ></NowaGra>
                <KontynuujGre :language="lang" 
                        v-else-if="plansza === 'kontynuuj-gre'" 
                        v-on:open-settings="openSettings" 
                        v-on:open-description="openDescription" 
                        v-on:go-nowa-gra="goNowaGra" 
                        v-on:go-to-plansza-poziomow="goToPlanszaPoziomow" 
                        ></KontynuujGre>
                <KonfiguracjaGry :language="lang"  
                        :komunikatPolaczenia="komunikatPolaczenia"
                        v-else-if="plansza === 'gracz1'" 
                        v-on:open-settings="openSettings" 
                        v-on:open-description="openDescription" 
                        v-on:go-next-event="goNext" 
                        v-on:go-nowa-gra="goNowaGra" 
                        v-on:configure-game="configureGame"
                        ></KonfiguracjaGry>
                <QRScreen :language="lang" :hash="gameHash"
                        v-else-if="plansza === 'qr-screen'" 
                        v-on:open-settings="openSettings" 
                        v-on:open-description="openDescription" 
                        v-on:go-next-event="goNext" 
                        v-on:go-nowa-gra="goNowaGra" 
                        v-on:go-to-poziomy="goToPlanszaPoziomow" 
                        ></QRScreen>
                <WpiszKod :language="lang"
                        v-else-if="plansza === 'gracz2-kod'" 
                        v-on:open-settings="openSettings" 
                        v-on:open-description="openDescription" 
                        v-on:show-spinner="showSpinner"
                        v-on:go-to-poziomy="goToPlanszaPoziomow" 
                        v-on:go-nowa-gra="goNowaGra" 
                        ></WpiszKod>
                <PlanszaPoziomow :language="lang" 
                        v-else-if="plansza === 'plansza-poziomow'" 
                        v-on:open-settings="openSettings" 
                        v-on:open-description="openDescription" 
                        v-on:go-start-gry="startGry" 
                        v-on:show-summary-results="showSummaryResults"
                        v-on:show-summary-report="showSummaryReport"
                        v-on:oplacenie="dokonajOplacenia"
                        :category="gameCategory"
                        :subcategory="gameSubCategory"
                        :offset="gameOffset"
                        v-on:show-category-details="showCategoryDetails"
                        ></PlanszaPoziomow>
                <PytanieOdpowiedz :language="lang" 
                        v-else-if="plansza === 'pytanie'" 
                        v-on:open-settings="openSettings" 
                        :category="gameCategory"
                        :subcategory="gameSubCategory"
                        :plansza="plansza"
                        v-on:show-spinner="showSpinner"
                        v-on:on-change-bottom-message="changeBottomMessage"
                        v-on:on-finished="finishedLevel"
                        :gameKey="gameKey"
                        :offset="gameOffset"
                        ></PytanieOdpowiedz>
                <PodsumowaniePoziomu :language="lang" 
                        v-else-if="plansza === 'podsumowanie-poziomu'" 
                        v-on:open-settings="openSettings" 
                        v-on:open-description="openDescription" 
                        v-on:go-start-gry="startGry"
                        :category="gameCategory"
                        :subcategory="gameSubCategory"
                        v-on:show-spinner="showSpinner"
                        v-on:go-to-poziomy="goToPlanszaPoziomow" 
                        v-on:go-to-nasze-odpowiedzi="goToNaszeOdpowiedzi" 
                        ></PodsumowaniePoziomu>
                <NaszeOdpowiedzi :language="lang" 
                        v-else-if="plansza === 'nasze-odpowiedzi'" 
                        v-on:open-settings="openSettings" 
                        v-on:open-description="openDescription" 
                        v-on:go-start-gry="startGry"
                        v-on:go-to-poziomy="goToPlanszaPoziomow" 
                        v-on:show-spinner="showSpinner"
                        :category="gameCategory"
                        :subcategory="gameSubCategory"
                        :klucz="klucz"
                        ></NaszeOdpowiedzi>
                <RaportGry :language="lang" 
                        v-else-if="plansza === 'raport-gry'" 
                        v-on:open-settings="openSettings" 
                        v-on:open-description="openDescription" 
                        v-on:go-next-event="goNext" 
                        v-on:show-spinner="showSpinner"
                        v-on:go-to-poziomy="goToPlanszaPoziomow" 
                        v-on:go-nowa-gra="goNowaGra"
                        ></RaportGry>
                <KupGre v-else-if="plansza === 'oplata'" 
                        :language="lang" 
                        v-on:dokonaj-oplacenia="dokonajOplacenia"
                        v-on:on-change-bottom-message="changeBottomMessage"
                        v-on:go-to-plansza-poziomow="goToPlanszaPoziomow" 
                        ></KupGre>
                <ScanQRCode v-else-if="plansza === 'gracz2-scan'" :language="lang" 
                        v-on:open-settings="openSettings" 
                        v-on:open-description="openDescription" 
                        v-on:go-to-poziomy="goToPlanszaPoziomow" 
                        v-on:go-nowa-gra="goNowaGra"
                        ></ScanQRCode>  
            </transition>   

        </div>
<!-- 
        <div v-show="dodaj_opinie">
            <DodajOpinie></DodajOpinie>
        </div>      

        <div v-show="nowa_wersja">
            <NowaWersja></NowaWersja>
        </div>
        -->      
        <div v-show="spinner">
            <SpinnerLoader></SpinnerLoader>
        </div>
        <div v-show="settings" v-on:close-event-listener="updateSettings">
            <SettingsScreen></SettingsScreen>
        </div>
        <div v-show="jak_dolaczyc">
            <JakDolaczyc :language="lang"></JakDolaczyc>
        </div>
        <div v-show="show_level_details">
            <CategoryDetails :language="lang" 
                :category="categoryDetails"
                v-on:on-show-responses="showDetailedResponses"
                ></CategoryDetails>
        </div>
        <div v-show="showBottomMessage" class="show-bottom-message">
            {{ showBottomMessage }}
        </div>
    </div>
</template>

<script>
import StartScreen from './components/StartScreen.vue'
import SpinnerLoader from './components/Spinner.vue'
import SettingsScreen from './components/SettingsScreen.vue'
import GameDescription from './components/GameDescription.vue'
import NowaGra from './components/NowaGra.vue'
import KontynuujGre from './components/KontynuujGre.vue'
import KonfiguracjaGry from './components/KonfiguracjaGry.vue'
import QRScreen from './components/QRScreen.vue'
import WpiszKod from './components/WpiszKod.vue'
import PlanszaPoziomow from './components/PlanszaPoziomow.vue'
import JakDolaczyc from './components/JakDolaczyc.vue'
import CategoryDetails from './components/CategoryDetails.vue'
import PytanieOdpowiedz from './components/PytanieOdpowiedz.vue'
import PodsumowaniePoziomu from './components/PodsumowaniePoziomu.vue'
import NaszeOdpowiedzi from './components/NaszeOdpowiedzi.vue'
import KupGre from './components/KupGre.vue'
import axios from 'axios'
import de from './locale/de.js';
import en from './locale/en.js';
import es from './locale/es.js';
import fr from './locale/fr.js';
import it from './locale/it.js';
import pl from './locale/pl.js';
import pt from './locale/pt.js';
import RaportGry from './components/RaportGry.vue'
import ScanQRCode from './components/ScanQRCode.vue'
export default {
    name: 'App',
    data() {
        return {
            plansza: 'start',
            spinner: false,
            settings: false,
            blured: false,
            jak_dolaczyc:false,
            show_level_details:false,
            translation: pl,
            gameHash: '',
            komunikatPolaczenia: '',
            lang: localStorage.getItem('language'),
            mode: localStorage.getItem('theme'),
            categoryDetails: 0,
            showBottomMessage: '',
            gameCategory: 0,
            gameSubCategory: 0,
            gameOffset:0,
            gameKey: 0,
            klucz:'',
        }
    },
    components: {
        StartScreen,
        SettingsScreen,
        SpinnerLoader,        
        GameDescription,        
        NowaGra,     
        KontynuujGre,
        KonfiguracjaGry,
        QRScreen,
        WpiszKod,
        PlanszaPoziomow,
        JakDolaczyc,
        CategoryDetails,
        PytanieOdpowiedz,
        PodsumowaniePoziomu,
        NaszeOdpowiedzi,
        RaportGry,
        KupGre,
        ScanQRCode
    },
    beforeMount() {
        if (!this.lang || this.lang.length!=2) {
            localStorage.setItem('language','pl');
            console.log('Zmieniam jezyk');
            this.settings = true;
            this.blured = true;
            this.lang = 'pl'
        }
        if (!this.mode || this.mode == 'null') {
            localStorage.setItem('theme','light');
            this.settings = true;
            this.blured = true;
            this.mode = 'light';
        }
        
        switch(localStorage.getItem('language'))
        {
            case 'de':
                this.translation = de;
                break;
            case 'en':
                this.translation = en;
                break;
            case 'es':
                this.translation = es;
                break;
            case 'fr':
                this.translation = fr;
                break;
            case 'it':
                this.translation = it;
                break;
            case 'pt':
                this.translation = pt;
                break;
            default:
                this.translation = pl;
                break;
        }
    },
    methods: {
        async dokonajOplacenia() {
            let temp;
            for(let level=1; level<=6; level++) {
                for(let sublevel=1; sublevel<=3; sublevel++) {
                    temp = JSON.parse(localStorage.getItem('levels-'+level+'-'+sublevel));
                    temp.unlocked = 'yes';
                    localStorage.setItem('levels-'+level+'-'+sublevel, JSON.stringify(temp));
                }
            }

            try {
                this.spinner = true;
                var data = new FormData();
                data.append('method', 'pay-game');
                data.append('hash', localStorage.getItem('game-settings-hash'));

                await axios.post('https://gra.wrealizacji.pl/api3.php?timer='+btoa(new Date().toUTCString()), data)
                .then((res) => {
                    this.spinner = false;
                        console.log(res);
                }).catch((error) => {
                    this.komunikatPolaczenia = this.translation.blad_polaczenia;
                    this.showBottomMessage = '';
                    this.spinner = false;
                    console.log(error)
                });
            } catch (err) {
                setTimeout(function () { 
                    this.dokonajOplacenia() 
                }.bind(this), 1000) 
            }

        },
        showSummaryResults() {

            //this.plansza = 'raport-gry'
            this.plansza = 'podsumowanie-poziomu'
        },
        showSummaryReport() {

            this.plansza = 'raport-gry'
            //this.plansza = 'podsumowanie-poziomu'
        },
        finishedLevel() {
            /*
            zapisac odpowiedzi do komorki zgodnosc w levels-x-x -> z ajax show-results-summary

            zapisac offset = 0;
            
            zastanowic się czy tutaj dodac category++ lub subcategory++

            dodatkowo zapisac wynik procentowy poprawnych odpowiedzi do obecnego levels-x-x
            */

            this.spinner = false;
            this.klucz = localStorage.getItem('klucz');
            this.plansza = 'podsumowanie-poziomu'
        },
        goToNaszeOdpowiedzi() {
            console.log('zmieniam plansze na nasze-odpowiedzi')
            this.plansza = 'nasze-odpowiedzi'
        },
        changeBottomMessage(val) {
            console.log('dolna wiadomosc')
            this.showBottomMessage = val;
        },
        async startGame() {
            try {
                this.spinner = true;

                if (!localStorage.getItem('game-offset'))
                    localStorage.setItem('game-offset', 0)
                else if (localStorage.getItem('game-offset')==20)
                    localStorage.setItem('game-offset', 0)
            
                this.gameOffset = localStorage.getItem('game-offset');
                let levelDet = JSON.parse(localStorage.getItem('levels-'+localStorage.getItem('klucz')));
                let subLevelID = localStorage.getItem('klucz');
                subLevelID = subLevelID.split('-');

                this.gameCategory = levelDet.position;
                this.gameSubCategory = subLevelID[1]
                this.gameKey = localStorage.getItem('klucz')

                var data = new FormData();
                data.append('method', 'start-game');
                data.append('device-id', localStorage.getItem('device-id'));
                data.append('hash', localStorage.getItem('game-settings-hash'));
                data.append('offset', localStorage.getItem('game-offset'));
                data.append('categoryID', levelDet.ID);
                data.append('subcategoryID', subLevelID[1]);

                await axios.post('https://gra.wrealizacji.pl/api3.php?timer='+btoa(new Date().toUTCString()), data)
                .then((res) => {
                    if (res.data.type == 'success') {
                        /*
                        zmiana statusu z 0 na 1
                        */
                        levelDet.status = 1;
                        localStorage.setItem('levels-'+localStorage.getItem('klucz'), JSON.stringify(levelDet));
                        this.plansza = res.data.board
                    } else {
                        setTimeout(function () { 
                            this.startGame() 
                        }.bind(this), 1000) 
                    }
                }).catch((error) => {
                    console.log(error);
                    this.komunikatPolaczenia = this.translation.blad_polaczenia;
                    this.spinner = false;
                });
            } catch (err) {
                setTimeout(function () { 
                    this.startGame() 
                }.bind(this), 1000) 
            }
        },
        async startGry() {
            /*
            najpierw sprawdzam jaki poziom mam odpalic
            potem sprawdzam czy jest darmowy lub oplacony

            jak tak to ponizej

            jak nie to pokazuje okno do kupienia gry

            */


            /*
            method: start-game-pre
            hash: 
            device-id

            włączam czekadełko
            czekam na odpowiedz type==ready
            */
            try {
                this.spinner = true;
                var data = new FormData();
                data.append('method', 'start-game-pre');
                data.append('device-id', localStorage.getItem('device-id'));
                data.append('hash', localStorage.getItem('game-settings-hash'));

                await axios.post('https://gra.wrealizacji.pl/api3.php?timer='+btoa(new Date().toUTCString()), data)
                .then((res) => {
                    if (res.data.type != 'ready') {
                        /*
                        sprawdzenie czy oplacone
                        */
                        if (res.data.paid != 'yes')
                        {
                            let $paid = localStorage.getItem('levels-'+res.data.klucz);
                            if ($paid == null) {
                                this.showBottomMessage = 'Bad level download';
                                this.spinner = false;
                                return;
                            }

                            $paid = JSON.parse($paid);
                            if ($paid == null) {
                                this.showBottomMessage = 'Bad level parse';
                                this.spinner = false;
                                return;
                            }                        

                            $paid = $paid.unlocked;
                            if (($paid == null || $paid != 'yes') && localStorage.getItem('alreadypaid') !== 'yes') {
                                this.plansza = 'oplata';
                                this.spinner = false;
                                return;
                            }
                        }

                        this.showBottomMessage = this.translation.oczekuje_na_druga_osobe_2;
                        setTimeout(function () { 
                            this.startGry() 
                        }.bind(this), 1000)
                    } else {
                        this.komunikatPolaczenia = '';
                        this.showBottomMessage = '';
                        this.spinner = false;

                        if (res.data.paid != 'yes')
                        {
                            let $paid = localStorage.getItem('levels-'+res.data.klucz);
                            if ($paid == null) {
                                this.showBottomMessage = 'Bad level download';
                                this.spinner = false;
                                return;
                            }

                            $paid = JSON.parse($paid);
                            if ($paid == null) {
                                this.showBottomMessage = 'Bad level parse';
                                this.spinner = false;
                                return;
                            }                        

                            $paid = $paid.unlocked;
                            if (($paid == null || $paid != 'yes') && localStorage.getItem('alreadypaid') !== 'yes') {
                                this.plansza = 'oplata';
                                this.spinner = false;
                                return;
                            }
                        } else {
                            let temp;
                            for(let level=1; level<=6; level++) {
                                for(let sublevel=1; sublevel<=3; sublevel++) {
                                    temp = JSON.parse(localStorage.getItem('levels-'+level+'-'+sublevel));
                                    temp.unlocked = 'yes';
                                    localStorage.setItem('levels-'+level+'-'+sublevel, JSON.stringify(temp));
                                }
                            }
                        }

                        localStorage.setItem('klucz', res.data.klucz)
                        if (res.data.offset)
                            localStorage.setItem('game-offset', res.data.offset)
                        console.log('idę do startgame')
                        /*
                        wysylam żądanie start-game
                        */
                        this.startGame()
                    }
                }).catch((error) => {
                    console.log(error);
                    this.komunikatPolaczenia = this.translation.blad_polaczenia;
                    this.showBottomMessage = '';
                    this.spinner = false;
                });
            } catch (err) {
                setTimeout(function () { 
                    this.startGry() 
                }.bind(this), 1000) 
            }
        },
        backToContinueGame() {
              this.plansza = 'kontynuuj-gre'
        },
        updateSettings() {
            this.mode = localStorage.getItem('theme')
            this.settings = false
            this.blured = false
        },
        joinGameQuestion() {
              this.jak_dolaczyc = true
              this.blured = true
              console.log('ma byc okno dialogowe')
        },
        showDetailedResponses(c,s) {
            this.gameCategory = c;
            this.gameSubCategory = s;
            this.plansza = 'nasze-odpowiedzi';
            this.show_level_details = false;
            this.blured = false;
        },
        showCategoryDetails(category) {
            this.blured = true;
            this.show_level_details = true;
            console.log(category)
            let det = new Array();
            det.push(localStorage.getItem('levels-'+category+'-1'));
            det.push(localStorage.getItem('levels-'+category+'-2'));
            det.push(localStorage.getItem('levels-'+category+'-3'));
            this.categoryDetails = JSON.stringify(det);
        },
        openSettings() {
              this.settings = true
              this.blured = true
        },
        goToPlanszaPoziomow() {
            console.log('do listy poziomow')
              this.plansza = 'plansza-poziomow';
        },
        showSpinner(val) {
              this.spinner = val;
        },
        openDescription() {
              this.plansza = 'opisGry';
        },
        goNowaGra() {
              this.plansza = 'nowa-gra';
              this.komunikatPolaczenia='';
        },
        goToPlansza(gdzie) {
              this.plansza = gdzie;
        },
        configureGame(imie1, imie2) {
            this.createGameAjax(imie1, imie2);
        },
        async createGameAjax (imie1, imie2, proba=1) {
            try {
                this.spinner = true;
                var data = new FormData();
                data.append('method', 'create-game');
                data.append('device-id', localStorage.getItem('device-id'));
                data.append('name1', imie1);
                data.append('name2', imie2);
                data.append('lang', localStorage.getItem("language"));
                data.append('unlocked', localStorage.getItem('alreadypaid'));

                await axios.post('https://gra.wrealizacji.pl/api3.php', data)
                .then((res) => {
                    if (res.data.type != 'success' && proba<10) {
                        proba++;
                        setTimeout(function () { 
                            this.createGameAjax(imie1, imie2, proba) 
                        }.bind(this), 1000)
                    } else if (res.data.type != 'success' && proba>=10) {
                        proba++;
                        this.komunikatPolaczenia = this.translation.blad_polaczenia;
                        this.spinner = false;
                    } else {
                        this.komunikatPolaczenia = '';
                        this.spinner = false;
                        
                        /*
                        zapisuje dane do polaczenia
                        */
                        sessionStorage.setItem('blik', res.data.blik);
                        localStorage.setItem('game-settings-hash', res.data.hash);
                        localStorage.setItem('game-hash-confirmed', '');
                        this.gameHash = res.data.hash;
                        localStorage.setItem('game-settings-imie1', imie1);
                        localStorage.setItem('game-settings-imie2', imie2);
                        localStorage.setItem('game-offset', "0");
                        
                        localStorage.setItem('game-settings-unlocked', localStorage.getItem('paid-game'));
                            
                        /*
                        zapisuje konfiguracje poziomow
                        */
                        let obj = {}
                        for(let level=1; level<=res.data.levels.length; level++) {
                            for(let sublevel = 1; sublevel<=3; sublevel++) {
                                obj = {
                                    zgodnosc: 0,
                                    status: 0,
                                    unlocked: (level<=3 && sublevel==1)?'yes':localStorage.getItem('paid-game'),
                                    name: res.data.levels[level-1].name,
                                    position:level,
                                    wynik: -1,
                                    ID: res.data.levels[level-1].ID
                                }
                                localStorage.setItem('levels-'+level+'-'+sublevel, JSON.stringify(obj));
                            }
                        }

                        /*
                        przekierowuje na pole z kodem qr i blikiem do przepisania
                        */
                        this.plansza = 'qr-screen'
                    }
                }).catch((error) => {
                    console.log(error);
                    this.komunikatPolaczenia = this.translation.blad_polaczenia;
                    this.spinner = false;
                });
            } catch (err) {
                proba++;
                if (proba < 10) {
                    setTimeout(function () { 
                        this.createGameAjax(imie1, imie2, proba) 
                    }.bind(this), 1000) 
                } else {
                    this.komunikatPolaczenia = this.transition.blad_polaczenia;
                    this.spinner = false;
                }
            }
        },
        goNext() {
            //let level = localStorage.getItem('level');
            let descReaded = localStorage.getItem('description-readed');
            let activeGame = localStorage.getItem('game-hash-confirmed');

            switch(this.plansza) {
                case 'start':
                    /*
                    sprawdzenie czy jest juz gra i jak jest to przejść od razu do kontynuowania
                    */
                    if (descReaded == null)
                    {
                        this.plansza = 'opisGry';
                    } 
                    else if (activeGame != '' && activeGame != null && activeGame.length > 10)
                    {
                        this.plansza = 'kontynuuj-gre';
                    }
                    else 
                    {
                        this.plansza = 'nowa-gra';
                    }
                    break;
                case 'opisGry':
                    /*
                    Z opisu jak jest gra to przechodzę na propozycję kontynuowania
                    Jak nie ma to na wybór kto zaczyna nową grę
                    */

                    if (activeGame != '' && activeGame != null && activeGame.length > 10)
                    {
                        this.plansza = 'kontynuuj-gre';
                    } else {
                        this.plansza = 'nowa-gra';
                    }
                    break;
                case 'kontynuuj-gre':
                    /*
                    do zrobienia
                    */
                    //this.plansza = 'nowa-gra';
                    break;
                case 'nowa-gra':
                    //this.plansza = 'gracz1';
                    break;
                case 'gracz1':
                    this.plansza = 'qr-screen';
                    break;
                case 'qr-screen':
                    this.plansza = 'gracz2-kod';
                    break;
                case 'gracz2-kod':
                    this.plansza = 'plansza-poziomow';
                    break;  
              }
        },
        clearGameData() {
            /*
            czyszczenie zapisanych danycy gry
            */
            sessionStorage.removeItem('blik');
            localStorage.removeItem('game-settings-hash');
            localStorage.removeItem('game-settings-imie1');
            localStorage.removeItem('game-settings-imie2');
            localStorage.removeItem('game-settings-unlocked');
            for(let level=1; level<=6; level++) {
                for(let sublevel=1; sublevel<=3; sublevel++) {
                    localStorage.removeItem('levels-'+level+'-'+sublevel);
                }
            }
        }
    },
    watch: {
        lang(l) {
            this.lang = l;
            switch(localStorage.getItem('language'))
            {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
            }

        },
        gameCategory(val) {
            console.log('W pamięci mam kod#2: '+val+'-'+this.gameSubCategory);
        }
    },
}
</script>

<style>
.show-bottom-message {
    position:fixed;
    bottom:0;
    left:0;
    right:0;
    padding: 10px;
    text-align:center;
    color:var(--bs-gradient-to);
    font-weight:bold;
    z-index: 600;
    background:white;
    border-top:1px solid var(--bs-gradient-to);
    /*-webkit-box-shadow: -1px 0px 24px 4px rgba(255, 255, 255, 1);
    -moz-box-shadow: -1px 0px 24px 4px rgba(255, 255, 255, 1);
    box-shadow: -1px 0px 24px 4px rgba(255, 255, 255, 1);*/
}
.window {
    position:fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
}
.main-window {
    background-color:var(--bs-button-background);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}

.slide-up-enter-active,
.slide-up-leave-active,
.slide-up-enter-from,
.slide-up-leave-to
{
  transition: all .3s ease-out;
}

/*
skad sie pojawia
*/
.slide-up-enter-from {
  opacity: 0; 

  transform: translateX(-100vw) scale(0.7);
}
/*
dokad znika
*/
.slide-up-leave-to {
  opacity: 0; 
  transform: translateX(100vw) scale(0.7);
}

.light {
    --bs-version-color:white;
    --bs-gradient-from: #ff9fc7;
    --bs-gradient-to: #f32878;
    --bs-button-color: white;
    --bs-start-text: white;

    --bs-button-text: black;
    --bs-button-background:white;

    --bs-gray-settings: #fff;
    --bs-settings-button-color: #666;
    --bs-settings-button-background: transparent;

    --bs-settings-button-color-active: #333;
    --bs-settings-button-background-active: white;
    --bs-settings-button-border: 1px solid #ccc;
    --bs-pink-button-color: white;
    --bs-box-background: #e0e0e0;
    --bs-second-bg: #02aace;
    --bs-gold: #ffa804;
    --bs-progressbar-background: #f0f0f0;
}
.dark {
    --bs-version-color: white;
--bs-gradient-from: #ff9fc7;
    --bs-gradient-to: #f32878;
    --bs-button-color: black;
    --bs-start-text: #f5f5f5;

    --bs-button-text: white;
    --bs-button-background: #333333;

    --bs-gray-settings: #1a1a1a;
    --bs-settings-button-color: #aaa;
    --bs-settings-button-background: transparent;

    --bs-settings-button-color-active: #fff;
    --bs-settings-button-background-active: #444;
    --bs-settings-button-border: 1px solid #555;

    --bs-pink-button-color: white;
    --bs-box-background: #777;
    --bs-second-bg: #02aace;
        --bs-gold: #ffa804;

    --bs-progressbar-background: white;

}

body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  background-color:white;
}

.blurred {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    filter: blur(3px); 
}


.help-box {
    background: var(--bs-box-background);
    border: var(--bs-settings-button-border);
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    position: relative;
    overflow: hidden;
}

.help-box::before {
    content: '🛟';
    position: absolute;
    top: -10px;
    right: -10px;
    font-size: 80px;
    opacity: 0.2;
    transform: rotate(15deg);
}

.help-text {
    position: relative;
    z-index: 1;
    color: var(--bs-settings-button-color-active);
    line-height: 1.5;
    margin: 0;
}

.help-text .line1 {
    font-weight: 600;
    margin-bottom: 5px;
}

.help-text .line2 {
    font-size: 14px;
    color: #6c757d;
}



</style>
